import i18n from 'i18next';

export const capitaliseStr = (s: string) => s ? s.substring(0, 1).toUpperCase() + s.substring(1).toLowerCase() : s;

export const documentType = (type: string) => i18n.t(type);

export const stringToFloat = (v: string): number => {
  // console.log(v, v.replaceAll(' ', ''), parseFloat(v.replaceAll(' ', '')));
  const n = parseFloat(v.replaceAll(',', ''));
  return Number.isNaN(n) ? 0 : n;
};

// export const b64EncodeUnicode = (str: string): string => {
//   return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
//     return String.fromCharCode(parseInt(p1, 16))
//   }))
// };

export const round = (number:any, places:any) => {
  number = (number) ? number : 0
  return Math.round(number * Math.pow(10, places)) / Math.pow(10, places)
}
